const reasons = [
  {
    icon: "ri-compass-3-line",
    title: "Diaspora-Centered Mission",
    desc: "Everything we do is built around the African Diaspora &mdash; our platform, our programs, and our partnerships are designed to serve this community with depth and authenticity.",
  },
  {
    icon: "ri-global-line",
    title: "Cross-Border Perspective",
    desc: "With roots in Nairobi and reach across the global diaspora, Harambee brings a uniquely cross-border lens to every collaboration.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Nairobi &amp; Africa-Based Opportunity",
    desc: "We are anchored in one of Africa&apos;s most dynamic business hubs, with deep local knowledge and global relevance that few platforms can match.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Professional, Disciplined &amp; Transparent",
    desc: "We operate with the highest standards of professionalism, transparency, and accountability &mdash; qualities that make us a credible long-term partner.",
  },
  {
    icon: "ri-book-2-line",
    title: "Education &amp; Readiness First",
    desc: "Our education-first model ensures that every partnership creates genuine value &mdash; not just awareness, but real capability and readiness.",
  },
  {
    icon: "ri-time-line",
    title: "Built for Long-Term Value",
    desc: "We are not interested in transactional promotion. We build structured, relationship-driven collaborations designed to create lasting, shared impact.",
  },
];

export default function WhyPartnerWithHarambee() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="relative order-2 lg:order-1">
          <img
            src="/assets/images/site/part-why-001-800x900.jpg"
            alt="Why partner with Harambee Global Ventures diaspora wealth creation"
            className="w-full h-[580px] object-cover object-top rounded-lg"
          />
          {/* Floating stat card */}
          <div className="absolute -bottom-6 -right-6 bg-[#C9A961] rounded-lg p-6 max-w-[210px] hidden md:block">
            <div className="font-['Cormorant_Garamond'] text-4xl font-bold text-[#1A2B1F] mb-1">
              Global
            </div>
            <div className="text-[#1A2B1F]/70 text-xs leading-relaxed font-medium">
              Nairobi-anchored with reach across the African Diaspora worldwide
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Why Partner With Us
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            A Platform Worth Partnering With
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-10">
            Harambee Global Ventures is more than an education platform &mdash; it is a trusted, relationship-driven ecosystem built for long-term impact. Here is why mission-aligned organizations choose to collaborate with us.
          </p>

          <div className="space-y-6">
            {reasons.map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#1A4D3C] text-base`} />
                </div>
                <div>
                  <h3
                    className="font-semibold text-[#2B2D2F] text-sm mb-1"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <p
                    className="text-[#6B6B6B] text-xs leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
